<template>
  <div class="shortcuts-setting"  v-if='boxData.judgeBox' :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex, }" @mousedown="stopDocument($event)">
    <div class="header" @mousedown="moveStart($event, true)" @mousemove="moveArea($event)" @mouseup="saveMoveState($event)" :style="{'cursor': (boxData.moveoks?'move':'move')}">快捷键</div>
    <div class="shortcuts-container">
      <ul class="shortcuts-list">
        <li>
          <span>复制</span>
          <span>CTRL+C</span>
        </li>
        <li>
          <span>剪切</span>
          <span>CTRL+X</span>
        </li>
        <li>
          <span>粘贴</span>
          <span>CTRL+V</span>
        </li>
        <li>
          <span>删除</span>
          <span>DELETE</span>
        </li>
        <li>
          <span>上移</span>
          <span>↑</span>
        </li>
        <li>
          <span>下移</span>
          <span>↓</span>
        </li>
        <li>
          <span>左移</span>
          <span>←</span>
        </li>
        <li>
          <span>右移</span>
          <span>→</span>
        </li>
        <li>
          <span>多选</span>
          <span>按住CTRL或SHIFT键进行选取</span>
        </li>
        <li>
          <span>置顶</span>
          <span>CTRL+SHIFT+[</span>
        </li>
        <li>
          <span>置底</span>
          <span>CTRL+SHIFT+]</span>
        </li>
        <li>
          <span>锁定</span>
          <span>CTRL+L</span>
        </li>
        <li>
          <span>保存</span>
          <span>CTRL+S</span>
        </li>
        <li>
          <span>空格</span>
          <span>预览或停止预览当前页面</span>
        </li>
        <li>
          <span>撤销</span>
          <span>CTRL+Z</span>
        </li>
        <li>
          <span>返回</span>
          <span>CTRL+Y</span>
        </li>
        <li>
          <span>编辑文字</span>
          <span>双击空白区</span>
        </li>
      </ul>
      <div class="notes">
        备注：如果您使用的Mac请将CTRL<br>切换为Command
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import popup from '../mixins/popup'
export default {
  mixins: [popup],
  data() {
    return {
      popupType: 'shortcuts',
      boxData  : {
        judgeBox : false, // 控制盒子开启关闭
        Zindex   : 0,     // 盒子层级
        data     : null,  // 盒子数据
        moveoks  : false, // 拖动判读啊数据
        oldMove  : {      // 计算移动增量
          x : 0,
          y : 0
        },
        fix : {           // 弹窗位置
          x : 0,
          y : 0
        }
      },
    }
  },
  props: ['dataMsg', 'boxDatas'],
  computed: {
    ...mapGetters([
      'TOOL',
    ])
  },
  watch : {
    // 'boxDatas.firstDatas' : function(val, oldval){ // 判断打开关闭
    //   let num = Array.indexOf(this.boxDatas.firstDatas, 'shortcuts');
    //   this.boxData.judgeBox = num < 0 ? false : true; // 判断是否打开

    //   if(this.TOOL && this.boxData.judgeBox){ // 打开的操作
    //     this.boxData.data = this.dataMsg.shortcuts;
    //     this.sprite       = this.boxData.data.sprite;
    //     this.boxData.Zindex   = (this.dataMsg.length + 1)*5;
    //     // this.boxData.fix.x    = this.dataMsg.shortcuts.posx;
    //     // this.boxData.fix.y    = this.dataMsg.shortcuts.posy;
    //   } else {
    //     this.$bus.emit('closeKeyBindings', false);
    //   }
    // }
    'boxData.judgeBox' (val) {
      if (!val) {
        this.$bus.emit('closeKeyBindings', false);
      }
    }
  },
  mounted() {
    this.$bus.on('Document_mousemove_vue',(event) => {
      let e = event ? event: window.event;
      if(this.boxData.moveoks) {
        this.moveArea(e);
        return false;
      }
    });
    this.$bus.on('Document_mouseup_vue',(event) => {
      let e = event ? event: window.event;
      if(this.boxData.moveoks) {
        this.saveMoveState(e);
        return false;
      }
    });
  },
  methods: {
    stopDocument(e){      // 防止事件冒泡
      e.stopPropagation();
      e.preventDefault();
    },
  }
}
</script>

<style lang="scss" scoped>
.shortcuts-setting {
  position: fixed;
  top: 0;
  left: 0;
  width: 275px;
  height: auto;
  z-index: 35;
  border: 1px solid #d8dee9;
  background: #d9ddea;
  overflow: hidden;
  font-family: 'Microsoft YaHei';
  font-size: 14px;
  color: #474261;
  overflow: hidden;
  box-shadow: 0px 0px 4px 0px
		rgba(54, 76, 204, 0.4);
	border-radius: 4px;
  box-sizing: border-box;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 7px 0 11px;
    height: 26px;
    background-color: #d9ddea;
    span {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #474261;
    }
    i {
      display: inline-block;
      background: #000;
      width: 12px;
      height: 12px;
      cursor: pointer;
    }
  }
  .shortcuts-container {
    width: 100%;
    height: auto;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    ul.shortcuts-list {
      width: 100%;
      margin-top: 18px;
      li {
        line-height: 1;
        text-align: left;
        margin-left: 22px;
        margin-bottom: 16px;
        span:first-child {
          margin-right: 10px;
          font-family: MicrosoftYaHei;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #474261;
        }
      }
    }
    div.notes {
      display: flex;
      align-items: center;
      line-height: 18px;
      width: 100%;
      height: 56px;
      padding-left: 20px;
      text-align: left;
      margin-top: 0px;
      font-size: 12px;
      background-color: #f8f8fe;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/shortcuts.vue